import { Component } from '@angular/core';
import {MarkdownPipe} from "../../core/pipes/markdown.pipe";
import { HttpClient } from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {catchError} from "rxjs/operators";

@Component({
  selector: 'app-privacy',
  standalone: true,
    imports: [
        MarkdownPipe
    ],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {

  public privacy: string = '';

  constructor(private http: HttpClient, private translate: TranslateService) {
    this.http.get("/assets/privacy-"+translate.currentLang+".md",  {responseType: "text"}).subscribe((data) => {
      this.privacy = data;
    }, (() => {
        this.http.get("/assets/privacy-de.md",  {responseType: "text"}).subscribe((data) => {
            this.privacy = data;
        });
    }));
  }

}
